import React, {useEffect, useRef, useState} from 'react';
import SignaturePad from "signature_pad";
import './Signature.css';
import {getRowsForTableConstructor, setRowsForTableConstructor} from "../../../../redux/reducers/act-reducer";
import {useDispatch, useSelector} from "react-redux";
import { getProfile } from "../../../../redux/reducers/user-profile-reducer";
import { MasterOfActsAPI } from "../../../../api/api";
import Button from "@material-ui/core/Button";
import { Dialog } from '../../../Dialog/Dialog';
import {makeStyles} from "@material-ui/core";


export const useStyles = makeStyles(() => ({
    greenButton: {
        color: '#0A8100',
        border: '1px solid #0A8100'
    },
}))

export const SignatureForTable = ({
    idSignature,
    allParams,
    setValues,
    values,
}) => {

    const classes = useStyles()
    const { user } = useSelector(getProfile);

    let canvas = useRef();
    let savePNGButton = useRef();
    let clearButton = useRef();

    const [open, setOpen] = useState(false)
    const [ref, setRef] = useState(false)

    useEffect(() => {
    if (  open === true) {
        canvas = canvas.current
        savePNGButton = savePNGButton.current
        clearButton = clearButton.current

        const signaturePad = new SignaturePad(canvas);
        signaturePad.backgroundColor = 'transparent'
        signaturePad.penColor = "rgb(60, 100, 244)";

     

        function resizeCanvas() {
            const ratio =  Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);

            signaturePad.fromData(signaturePad.toData());
        
           
        }

        window.onresize = resizeCanvas;
        resizeCanvas();

        function dataURLToBlob(dataURL) {
          const parts = dataURL.split(';base64,');
          const contentType = parts[0].split(":")[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], { type: contentType });
        }

        savePNGButton.addEventListener("click", async () => {
            if (signaturePad.isEmpty()) {
                alert("Please provide a signature first.");
            } else {
                
                const dataURL = signaturePad.toDataURL("image/png");
               

                let imageBlob = dataURLToBlob(dataURL);
                
                const response = await MasterOfActsAPI.uploadSignature(imageBlob, user.id);
                
                if (response.status === 201) {
                    
                    const fakeRows = JSON.parse(JSON.stringify(values));
                    
                    const newRows = fakeRows.map((el, index) => {
                        if (index + 1 === allParams.id) {
                            let newEl = {...el}
                            newEl[allParams.field] = response.data.id
                            return newEl
                        }
                        return el
                    })
                    setValues(newRows);
                }  
            }
        });

        clearButton.addEventListener("click", () => {
            signaturePad.clear();
        });
    }
    }, [ref]);

    const handleOpen = () => {
        setOpen(!open)
    }

    const handleRef = () => {
        setRef(!ref)
    }

    const handleDeleteSignature = () => {

        const fakeRows = JSON.parse(JSON.stringify(values))
                    
        const newRows = fakeRows.map((el, index) => {
            if (index + 1 === allParams.id) {
                let newEl = {...el}
                newEl[allParams.field] = null
                return newEl
            }
                return el
            })
        setValues(newRows)
    }


    return (
     
            <React.Fragment>
                {idSignature === null ?
                   <Button  
                        variant={'contained'}
                        color={'primary'}
                        onClick={handleOpen}
                        style={{width: '120px'}}
                    >
                        Подписать
                    </Button>
                :   
                    <Button  
                        variant={'contained'}
                        color={'secondary'}
                        onClick={handleDeleteSignature}
                        style={{width: '120px'}}
                    >
                        Отменить
                    </Button>
                }
                <Dialog
                        open={open}
                        title={'Форма подписи'}
                        handleClose={() => {handleOpen(); handleRef();}}
                        fullWidth
                        maxWidth={'sm'}
                        actions={<Button 
                            ref={savePNGButton} 
                            type="button"  
                            data-action="save-png"
                            variant="outlined"
                            classes={{outlined: classes.greenButton}}
                            onClick={() => {handleOpen(); handleRef();}}
                        >
                            Подписать 
                        </Button>}
                    >   
                        {ref === false &&
                            <Button variant="contained" color="primary" onClick={handleRef}>Создать подпись</Button>
                        }
                            {ref &&
                                <div className="sign">
                                    <canvas ref={canvas}> </canvas>    
                                    <div className="controls">
                                        <Button 
                                            variant="contained"
                                            color="primary"
                                            ref={clearButton} 
                                            type="button" 
                                            className="button clear" 
                                            data-action="clear"                    
                                        >
                                            Очистить 
                                        </Button>
                                    </div>
                                </div>
                            }
                    </Dialog>

            </React.Fragment>
    );
};

